import { render, staticRenderFns } from "./RecommendPage.vue?vue&type=template&id=324d6974&scoped=true"
import script from "./RecommendPage.vue?vue&type=script&lang=js"
export * from "./RecommendPage.vue?vue&type=script&lang=js"
import style0 from "./RecommendPage.vue?vue&type=style&index=0&id=324d6974&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324d6974",
  null
  
)

export default component.exports